var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckShape = function SvgCheckShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.018 1.216A2.62 2.62 0 0 1 6 .313c.792 0 1.5.35 1.982.903a2.62 2.62 0 0 1 2.643 1.7c.132.351.186.728.16 1.102a2.62 2.62 0 0 1 .666 3.071 2.6 2.6 0 0 1-.667.893 2.62 2.62 0 0 1-.763 2.04 2.62 2.62 0 0 1-2.04.762 2.62 2.62 0 0 1-3.07.667 2.6 2.6 0 0 1-.893-.667 2.62 2.62 0 0 1-2.643-1.7 2.6 2.6 0 0 1-.16-1.102A2.62 2.62 0 0 1 .314 6c0-.792.35-1.5.903-1.982a2.62 2.62 0 0 1 1.7-2.643 2.6 2.6 0 0 1 1.102-.159m4.088 3.726a.437.437 0 1 0-.712-.509L5.506 7.076l-.947-.948a.438.438 0 0 0-.618.619l1.312 1.312a.438.438 0 0 0 .665-.055z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckShape;